import * as util from '../../library/utilitys';

export const GlobalStates = {
    Action: {
        Mode: '',
        OffCanvas:{
            mode: '',
            show: false
        },
        Inline:{
            mode: '',
            show: false
        },        
        Modal:{
            mode: '',
            show: false,
        },
        Alert: {
            mode: '',
            show: false
        },
        Toast: {
            mode: '',
            show: false
        },
        PreviewFile: {
            show: false,
            data: null
        },
        Loading: { 
            submit: false,
            dataTable: true,
            delete: false
         },
    },
    Parameters: {},
    Searchs: {},
    DataTable: {
        rows: [],
        pagination:{
            currentPage: null, 
            pageSize: process.env.REACT_APP_PAGE_SIZE, 
            sectionSize: process.env.REACT_APP_SECTION_SIZE, 
            totalRows: 0
        }
    },
    Inputs: {},
    InputGroup: {},
    Deletes: {
        checkAll: false,
        deletes: [],
    },
    Masterbase: {},
    Operation: {
        Submit: false,
        Search: false,
        Delete: false
    },
    Token: {
        Expried: false
    }
}